"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getQueryArguments_1 = __importDefault(require("./getQueryArguments"));
/** Request string that defines all selectable GraphQL products fields
 * Fetches price on base product and on dimension if dimension has no price defined
 */
var graphQlProducts = "{\n  akl\n  orderNumber\n  sku\n  defaultCategory\n  image\n  name\n  availability {\n    message\n    state\n  }\n  productLink\n  price {\n    currency\n    value\n    saving {\n      type\n      value\n    }\n    amount\n    isStartPrice\n    unit\n    uvp\n    valueOld\n    valueUnit\n  }\n  brand {\n    name\n    image\n  }\n  powerEfficiency {\n      iconUrl\n      link\n  }\n  productDataSheet{\n    iconUrl\n    link\n    text\n  }\n  dimensions {\n    displayName\n    name\n    type\n    axisType\n    values {\n      sku\n      availabilty {\n        message\n        state\n      }\n      displayText\n      image\n      isSelected\n      rgb\n      price {\n        currency\n        value\n        saving {\n          type\n          value\n        }\n        amount\n        isStartPrice\n        unit\n        uvp\n        valueOld\n        valueUnit\n      }\n      variationMainImage\n    }\n  }\n  rating {\n    count\n    value\n  }\n  tracking {\n    token  \n    onViewUrl\n  }\n}";
var graphQlValues = "{title, products " + graphQlProducts + "}";
/**
 * Builds the graphQLQuery string that's sent to the API
 * @param rdeType Type of the recommendation engine that's requested ('prudSys', 'alternative', ...)
 * @param articleNo articleNo of the source product that's used for the rde
 */
var buildGraphQLQuery = function (_a, locale) {
    var rdeType = _a.rdeType, rdeArguments = __rest(_a, ["rdeType"]);
    return "{\n          " + rdeType + "(" + getQueryArguments_1.default(rdeArguments, locale)[rdeType] + ") " + graphQlValues + "\n  }";
};
exports.default = buildGraphQLQuery;
//# sourceMappingURL=buildGraphQLQuery.js.map